/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CountriesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List all countries
     * Return a lean list of countries without loading ORM relationships.
     *
     * Uses a simple SQL projection to avoid any eager-loading overhead that can
     * occur with large ORM entity loads.
     * @returns any Successful Response
     * @throws ApiError
     */
    public listCountriesApiV1CountriesGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/countries/',
        });
    }
    /**
     * List all countries
     * Return a lean list of countries without loading ORM relationships.
     *
     * Uses a simple SQL projection to avoid any eager-loading overhead that can
     * occur with large ORM entity loads.
     * @returns any Successful Response
     * @throws ApiError
     */
    public listCountriesApiV1CountriesGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/countries/',
        });
    }
}
